/* Global utilities that should be loaded as soon as possible */
window.ontech = window.ontech || {};

/* URL */
ontech.getQueryStringByName = function(name) {
    var match = RegExp('[?&]' + name + '=([^&]*)').exec(window.location.search);
    return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
}

/* Cookies */
ontech.removeCookie = function(name) {
    Cookies.remove(name,  { "domain": ".ontechsmartservices.com" });
}

ontech.orderAttributesToClear = {
    [NoteAttribute._20_PERCENT_OFF_SELECT_ITEMS]: null,
    [NoteAttribute.AGENT_ID]: null,
    [NoteAttribute.APPOINTMENT_FROM]: null,
    [NoteAttribute.APPOINTMENT_TO]: null,
    [NoteAttribute.APPOINTMENT_WINDOW]: null,
    [NoteAttribute.CLIENT_NAME]: null,
    [NoteAttribute.CONSENT_TO_CALL]: null,
    [NoteAttribute.LOGGED_IN]: null,
    [NoteAttribute.MEMBER_FREE_INSTALL_TAG]: null,
    [NoteAttribute.MEMBERSHIP]: null,
    [NoteAttribute.PARENT]: null,
    [NoteAttribute.PARENT_WORK_ORDER]: null,
    [NoteAttribute.PARTNER_ID]: null,
    [NoteAttribute.PRODUCT_SKU]: null,
    [NoteAttribute.SCHEDULED_DATE]: null,
    [NoteAttribute.TECH_DELIVERED_FLAG]: null,
    [NoteAttribute.TECH_ID]: null,
    [NoteAttribute.TOTAL_BENEFIT_VALUE]: null
}

ontech.clearAuthCookies = function () {
    ontech.removeCookie(CookiesConstants.AUTH_TOKEN);
    ontech.removeCookie(CookiesConstants.AUTH_ROLE);
    ontech.removeCookie(CookiesConstants.AUTH_USER);
    ontech.removeCookie(CookiesConstants.AUTH_ACTION);
    ontech.removeCookie(CookiesConstants.AUTH_ORDER_NUMBER);
    ontech.removeCookie(CookiesConstants.AUTH_EMAIL_ADDRESS);
}

ontech.getCookie = function(name) {
    return Cookies.get(name);
}

// ToDo: Why is the source argument supposed to be for?
ontech.setCookie = function (name, value, source) {
    Cookies.set(name, value, { "domain": ".ontechsmartservices.com", "Secure": "true", "SameSite": "None" });
}

// ToDo: Remove once confirmed all usage has been changed to generateUUID()
ontech.generateUUID = function() {
    return generateUUID();
}

/**
 * This method will update the referrer param before redirecting
 *
 * Usage:
 * replace: window.location.href = '/cart';
 * with:    ontech.redirect('/cart');
 *
 * @param url URL to redirect to
 */
ontech.redirect = function (url) {
    let currentLocation, curLocRefIndex, delim, redirectDebug, redirectURL, urlRefIndex;

    // ToDo: Why have this flag if there is no way to set it other than doing a code change to use
    //       it.
    redirectDebug = false;
    currentLocation = JSON.parse(JSON.stringify(window.location.href));

    urlRefIndex = url.indexOf('referrer');
    if (urlRefIndex > 0) {
        url = url.substr(0,urlRefIndex - 1);
    }

    curLocRefIndex = currentLocation.indexOf('referrer');
    if (curLocRefIndex > 0) {
        currentLocation = currentLocation.substr(0,curLocRefIndex - 1);
    }

    delim = url.indexOf('?') > 0 ? "&" : "?";
    redirectURL = `${url}${delim}referrer=${currentLocation}`;

    if (redirectDebug) {
        ontech.log.debug(`$$$ redirect BEGIN: target URL = "${url}"`);
        ontech.log.debug(`$$$ redirect: currentLocation = "${window.location.href}"`);
        ontech.log.debug(`$$$ redirect END: redirectURL = "${redirectURL}"`);
    }

    window.location.href = redirectURL;
};

ontech.determineErrorMessage = function (err) {
    var errors = {};

    if (typeof(err) == 'object') {
        if (err && err.responseJSON && err.responseJSON.message) {
            errors.responseJSON_message = err.responseJSON.message;
        }
    
        if (err && err.statusText) {
            errors.statusText = err.statusText;
        }           
    } else {
        errors.error = err;
    }

    return errors;
}

ontech.getSessionId = function () {
    var key = 'ontech_session_id';
    if (!ontech.getCookie(key)) {
        var newSessionId = generateUUID();
        var offset = -6;
        var nd = new Date(new Date().getTime() + offset * 3600 * 1000).toUTCString().replace(/ GMT$/, "");
        var createdDate = nd.toString() + " (MT)";
        ontech.setCookie(key, newSessionId);
        ontech.setCookie('ontech_session_idCreated', createdDate);
        
        // *** STATE debugger confirmed and removed. TODO: REMOVE THIS LATER WHEN STATE VERIFIED ***
        //ontech.setCookie('ontech_session_idCreated', nd.toString() + " (MT)");
        var sessionInfo = {
            sessionId: newSessionId,
            sessionCreatedDate: createdDate
        };
        ontech.state.do('onGeneralSessionChanged', sessionInfo);
        return newSessionId;
    }
    return ontech.getCookie(key);
}
// *** getOrderAttributeUpdateString ***
ontech.getOrderAttributeUpdateString = function (newStep) {
    var enableUpdateSteps = false; // Turned off on 1/7/2021 because steps taking a lot of space in order attributes

    if (enableUpdateSteps) {
        var retVal;
        if (!ontech.state.get(State.LOG_ORDER_ATTRIBUTE_UPDATE_STEPS)) {
            ontech.state.do('onLogOrderAttributeStepsChanged', newStep);
            retVal = newStep;
        } else {
            var current = ontech.state.get(State.LOG_ORDER_ATTRIBUTE_UPDATE_STEPS);
            var newValue = `${current}|${newStep}`;
            ontech.state.do('onLogOrderAttributeStepsChanged', newValue);
            retVal = newValue;
        }
        return retVal;   
    }
    else {
        return null;
    }
}

ontech.routerDebug = function (msg, data) {
    if (ontech.state.get(State.Settings.ROUTER_DEBUG)) {
        ontech.log.debug(`^^^ routerdebug: ${msg} ^^^`, data);
    }      
}

ontech.getSecurityQuerystring = function (url) {
    var token = ontech.getCookie(CookiesConstants.AUTH_TOKEN);
    var sessionId = ontech.state.get(State.SESSION_ID);
    // ordernumber: The tokens do NOT have the order prefix, need to prepend here
    var orderNumber = shopifyOrderNumberWithPrefix(ontech.getCookie(CookiesConstants.AUTH_ORDER_NUMBER));
    var emailAddress = ontech.getCookie(CookiesConstants.AUTH_EMAIL_ADDRESS);
    var delim = url.toLowerCase().indexOf('?') > 0 ? '&' : '?';
    var retVal;

    if (typeof token != "undefined" && typeof sessionId != "undefined") {
        retVal = `&t=${token}&sessionid=${sessionId}`;
    } else if (typeof orderNumber != "undefined" && typeof emailAddress != "undefined") {
        // if the source url already has ordernumber, use that instead of the one from the cookie
        if (url.toLowerCase().indexOf("ordernumber") < 0) {            
            retVal = `${delim}ordernumber=${orderNumber}`;
        }

        if (url.toLowerCase().indexOf("emailaddress") < 0) {
            retVal = `${retVal ? retVal + '&': delim}emailaddress=${emailAddress}`;            
        }
    }    
    return retVal;
}

// *** ontech.errorRedirect ***
ontech.errorRedirect = function (message) {
    ontech.redirect(`/pages/error?msg=${encodeURI(message)}`);
}

// *** ontech.addTokenSecurityParameters ***
// ordernumber: orderNumber SHOULD have the order prefix
ontech.addTokenSecurityParameters = function (url, orderNumberWithPrefix) {
    if (ontech.state.get(State.Settings.ENABLE_TOKEN_SECURITY)) {
        var securityQuerystring = ontech.getSecurityQuerystring(url);
        if (securityQuerystring) {
            // we need to first check if already in the URL before adding to avoid two instances
            if (url.indexOf('ordernumber') < 0 && securityQuerystring.indexOf('ordernumber') < 0) {
                var delim = url.indexOf('?') >= 0 ? '&' : '?';
                url = `${url}${delim}ordernumber=${orderNumberWithPrefix}`;
            }
            url = `${url}${securityQuerystring}`;
            ontech.log.debug(`$$$ addTokenSecurityParameters: securityQuerystring = "${securityQuerystring}"`);
            ontech.log.debug(`$$$ addTokenSecurityParameters: final URL = "${url}"`);
        } else {
            ontech.errorRedirect('Error processing token security parameters.');            
        }
    }
    return url;
}

ontech.tokenBreak = function (message) {
    const tokenDebug = ontech.state.get(State.Settings.TOKEN_DEBUG);
    if (tokenDebug) {
        if (message) {
            ontech.log.debug(`token debug: ${message}`, 'info');
            debugger; // --- leave this in ---
        }       
    }
}

ontech.getSchedulerUrl = function () {
    let enableThemeScheduler = ontech.state.get(State.Settings.ENABLE_THEME_SCHEDULER);
    if (enableThemeScheduler) {
        return ontech.state.get(State.Settings.SCHEDULER_URL);
    } else {
        return ontech.state.get(State.Settings.SUCCESS_URL);
    }
}

ontech.getServiceSchedulerUrl = function () {
    let enableThemeScheduler = ontech.state.get(State.Settings.ENABLE_THEME_SCHEDULER);
    if (enableThemeScheduler) {
        return ontech.state.get(State.Settings.SERVICE_SCHEDULER_URL);
    } else {
        return ontech.state.get(State.Settings.SUCCESS_URL);
    }
}

ontech.redirectToContinueShoppingUrl = function () {
    let ontech_partner_url = ontech.state.get(State.Partner.URL);
    if (ontech_partner_url && ontech_partner_url.length > 0) {
        window.location.href = ontech_partner_url;
    } else {
        window.location.href = '/';
    }
}

// check if the cart contains an item with the specific tag
ontech.findItemInCartWithTag = function (cart, tag) {
    let tagItemLinePosition;
    try {
        let nonGroupedItemCount;
        tagItemLinePosition = -1;
        nonGroupedItemCount = 0;
        for (let i = 0; i < cart.items.length; i++) {
            let lineItem = cart.items[i];
        
            // check to make sure it's not part of a bundle or auto add on
            if (!lineItem.properties[Cart.Properties.GROUP_ID] || lineItem.properties[Cart.Properties.GROUP_ID].substr(0, 13) == lineItem.product_id) {
                nonGroupedItemCount++;
            }
        
            if (lineItem.properties[Cart.Properties.PRODUCT_TAGS] && lineItem.properties[Cart.Properties.PRODUCT_TAGS].includes(tag)) {
                tagItemExists = true;
                tagItemLinePosition = nonGroupedItemCount;
            }
        }
    } catch (error) {
        this.customLog("error in findItemInCartWithTag: " + error.responseText);   
    }
    
    return tagItemLinePosition;
}

ontech.isZipcodeValid = function (zipcode) {
    let regex = new RegExp(/^\d{5}[-\s]?(?:\d{4})?$/);
    return regex.test(zipcode);
}

// return true if the user is in a flow that should show slide cart, else if not
ontech.isSlideCartEnabled = function () {
    let showSlideCart, isOrderEdit, isOss;
    showSlideCart = true;
    isOrderEdit = ontech.state.get(State.ACTION) && ontech.state.get(State.ACTION) === Actions.ORDER_EDIT;
    isOss = isOssFlow();

    // check partner configuration
    if (!ontech.state.get(State.Partner.ENABLED_SLIDE_CART) || ontech.state.get(State.VENDOR_DEALS.SLIDE_CART_DISABLED)) {
        showSlideCart = false;
    }

    // disable for other flows
    if (isOrderEdit || isOss) {
        showSlideCart = false;
    }

    //disable if on scheduler page
    if (window.location.pathname.includes(ontech.getSchedulerUrl()) ||
        window.location.pathname.includes(ontech.getServiceSchedulerUrl())) {
        return false;
    }

    return showSlideCart;
}



ontech.showItemAddedToCartNotification = function () {
    try {
        theme.Notify.open("success", false, true);
    } catch (err) {
        // in OE flow when adding to cart, the notification sucess (blue bar) doesn't exist. It's ok this fails.
        //ontech.log.warn(`could not open add to cart notification (ok for order edit)`);
    }
    
}

ontech.showSlideCart = function () {
    theme.RightDrawer.open();
    ajaxCart.load();
}

// Return the page from the url
// Used to apply cart-ajax to slide cart and /cart pages. 
// Strip any ?, queryString, and #
ontech.getPageUrl = function() {
    let hrefArray =
        window.location
            .toString()
            .replace(location.search, "")
            .replace("#", "")
            .split('/');
    return hrefArray[hrefArray.length - 1].split('?')[0];
}

ontech.extractHostname = function(url) {
    try {
        var hostname;
        if (url.indexOf("//") > -1) {
            hostname = url.split('/')[2];   // find & remove protocol (http, ftp, etc.) and get hostname
        } else {
            hostname = url.split('/')[0];
        }
        hostname = hostname.split(':')[0]; // find & remove port number
        hostname = hostname.split('?')[0]; // find & remove "?"
        return hostname;
    } catch (err) {
        var errMsg = `Error in extractHostname on theme.liquid`;
        ontech.log.error(errMsg, err);
    } 
}

ontech.getReferrer = function(currentLocation) {
    try {
        if (document.referrer && document.referrer.length > 0) {
            return ontech.extractHostname(document.referrer);
        } else if (currentLocation.href.split('?')[1]) { 
            var urlParams = new URLSearchParams(currentLocation.search);
            var paramReferrer = urlParams.get('referrer');
            if (paramReferrer) {
                return extractHostname(paramReferrer); 
            } else {
                return '';
            }
        } else {
            return '';
        }
    } catch (err) {
        var errMsg = `Error in getReferrer on theme.liquid`;
        ontech.log.error(errMsg, err);
    }         
}
